<template>
  <div id="aboutUs">
    <h1 style="font-size: 150%;">Impressum</h1>
    <v-divider></v-divider>
    <p class="imp">V.A.M. Innsbruck
      <br>Prüfzentrum für Werkstoffe und Maschinenbau
      <br>Anichstraße 26 – 28
      <br>6020 Innsbruck
      <br>T +43-50902 808 750
      <br>F +43-50902 808 901
      <br>info(at)vam-innsbruck.at
      <br>Direktion: Mag. Günther Laner
      <br>Operative Leitung: Anton Raß
      <br>
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style>
#aboutUs {
  background-color: white;
  width: 60%;
  margin: 5% auto 0% auto;
  border: 2px solid black;
  border-radius: 5px;
  text-align: center;
  font-size: 150%; 
  opacity: 0.85;
  filter: alpha(opacity=85);
}
</style>
